import * as React from 'react';
import classnames from 'classnames';

import PromptExit from 'libs/router/prompt-exit/PromptExit';
import Input from 'components/inputs/input/Input';
import InlineEditingWrapper from 'components/inline-editing-wrapper/InlineEditingWrapper';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import type { Campaign } from 'types';

import './campaign-overview-budget-note.scss';

applyTranslations(require('./campaign-overview-budget-note.i18n.json'));

type Props = {
  campaign: Campaign,
  onBudgetNoteUpdate: (a: string) => void
};

function wrapperComponent() {
  return (
    <Input
      focusOnMount
      width="responsive"
      value="" // will be overwritten in InlineEditingWrapper
      maxLength={1000}
      placeholder={__t('campaign-overview-budget-note.edit_note_placeholder')}
    />
  );
}

const CampaignOverviewBudgetNote = (
  {
    campaign,
    onBudgetNoteUpdate
  }: Props
): JSX.Element => {
  const [isInEditMode, setEditMode] = React.useState(false);

  const budgetNoteText = campaign.budgetNote || __t('campaign-overview-budget-note.no_note_yet_label');

  const noteViewClassName = classnames('campaign-overview-budget-note__note-text', {
    'campaign-overview-budget-note__note-text--empty': !campaign.budgetNote
  });

  // view mode
  return (
    <div className="campaign-overview-budget-note">
      {isInEditMode && (
        <React.Fragment>
          <PromptExit type="page" />
          <div className="campaign-overview-budget-note__edit-wrapper">
            <InlineEditingWrapper
              inForceEditMode
              initialValue={campaign.budgetNote || ''}
              onSubmit={(newValue: string) => {
                onBudgetNoteUpdate(newValue);
                setEditMode(false);
              }}
              onCancel={() => setEditMode(false)}
              renderEditMode={() => wrapperComponent()}
              renderViewMode={() => wrapperComponent()}
            />
          </div>
        </React.Fragment>
      )}
      {!isInEditMode && (
        <React.Fragment>
          <span className={noteViewClassName}>
            {budgetNoteText}
          </span>
          <ActionButton onClick={() => setEditMode(true)}>
            {__t('campaign-overview-budget-note.edit_note_label')}
          </ActionButton>
        </React.Fragment>
      )}
    </div>
  );
};

export default CampaignOverviewBudgetNote;
